import classNames from 'classnames';
import './index.less';

export const LoadingIcon = (props: React.HTMLAttributes<HTMLDivElement>)=>{
  return <div className={classNames('loading-spin', props.className)} style={props.style}>
    <div className='cover-mask'></div>
  </div>;
};